/**
 * Tipo de benefícios
 */
export enum BenefitsClubType {
  /**
   * Cupom
   */
  COUPON = 'COUPON',

  /**
   * Link externo
   */
  HYPERLINK = 'HYPERLINK',
}

/**
 * Situação da benefício
 */
export enum BenefitsStatus {
  /**
   * Ativo
   */
  ENABLED = 'ENABLED',

  /**
   * Desativado
   */
  DISABLED = 'DISABLED',
}

export class Benefit {
  uuid!: string;
  partner_uuid!: string;
  partner_name?: string;
  business_unit_uuid?: string;
  title?: string;
  description!: string;
  spotlight!: boolean;
  is_image_default!: boolean;
  status!: BenefitsStatus;
  type!: BenefitsClubType;
  coupon?: string;
  hyperlink?: string;
  image_url?: string;
  start_date!: string;
  end_date!: string;
  team_uuid?: string;
  team_name?: string;
  team_image?: string;
  created_at!: string;
  updated_at!: string;
}

export const colorByBenefitStatus: Record<BenefitsStatus, string> = {
  [BenefitsStatus.DISABLED]: 'red.500',
  [BenefitsStatus.ENABLED]: 'green.500',
};

export const translateBenefitStatus = (status: BenefitsStatus): string => {
  switch (status) {
    case BenefitsStatus.ENABLED:
      return 'Ativo';
    case BenefitsStatus.DISABLED:
      return 'Desativado';
    default:
      return status;
  }
};

export const translateBenefitType = (type: BenefitsClubType): string => {
  switch (type) {
    case BenefitsClubType.COUPON:
      return 'Cupom';
    case BenefitsClubType.HYPERLINK:
      return 'Link externo';
    default:
      return type;
  }
};
